// src/pages/ingresos/components/POFilters.jsx
import React from "react";

/**
 * Barra de filtros para Ingresos
 * - Buscar por OS / oferta
 * - Buscar por cliente
 * - Filtro de estado
 * - Filtro por tecnico
 * - Filtro por instrumento (Tag / Serie)
 */
export default function POFilters({
  q,
  setQ,
  clientFilter,
  setClientFilter,
  poStatus,
  setPoStatus,
  techFilter,
  setTechFilter,
  techOptions = [],
  instrumentIdFilter,
  setInstrumentIdFilter,
  instrumentTagSerialFilter,
  setInstrumentTagSerialFilter,
}) {
  const hasAnyFilter =
    !!q ||
    !!clientFilter ||
    !!poStatus ||
    !!techFilter ||
    !!instrumentIdFilter ||
    !!instrumentTagSerialFilter;

  const clearAll = () => {
    setQ("");
    setClientFilter("");
    setPoStatus("");
    setTechFilter("");
    setInstrumentIdFilter("");
    setInstrumentTagSerialFilter("");
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-500">
          {hasAnyFilter
            ? "Filtro activo — se mantiene aunque edites o cambies de pantalla."
            : "Filtrá las órdenes de servicio."}
        </span>
        {hasAnyFilter && (
          <button
            type="button"
            onClick={clearAll}
            className="text-xs font-medium text-slate-300 hover:text-white rounded-md border border-white/15 hover:bg-white/10 px-2.5 py-1 transition"
          >
            ✕ Limpiar filtros
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
        <div>
          <label className="block text-xs text-slate-400 mb-1">
            OS / oferta
          </label>
          <input
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white placeholder:text-slate-400"
            placeholder="Ej: OS-6499 o CT-123"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-xs text-slate-400 mb-1">
            Cliente
          </label>
          <input
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white placeholder:text-slate-400"
            placeholder="Nro, nombre o CUIT"
            value={clientFilter}
            onChange={(e) => setClientFilter(e.target.value)}
          />
        </div>

        <div className="w-full">
          <label className="block text-xs text-slate-400 mb-1">Estado</label>
          <select
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white"
            value={poStatus}
            onChange={(e) => setPoStatus(e.target.value)}
          >
            <option value="">Todos los estados</option>
            <option value="unassigned">Sin asignar</option>
            <option value="assigned">Asignada</option>
            <option value="in_progress">En proceso</option>
            <option value="done">Terminada</option>
            <option value="delivered">Entregada</option>
          </select>
        </div>

        <div className="w-full">
          <label className="block text-xs text-slate-400 mb-1">Tecnico</label>
          <select
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white"
            value={techFilter}
            onChange={(e) => setTechFilter(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="__none">Sin tecnico</option>
            <option value="Varios">Varios</option>
            {techOptions.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-end">
        <div>
          <label className="block text-xs text-slate-400 mb-1">
            ID instrumento
          </label>
          <input
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white placeholder:text-slate-400"
            placeholder="Ej: 1024 o 0001024"
            value={instrumentIdFilter}
            onChange={(e) => setInstrumentIdFilter(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs text-slate-400 mb-1">
            Tag / Serie
          </label>
          <input
            className="w-full rounded-md bg-white/10 border border-white/10 px-3 py-2 text-white placeholder:text-slate-400"
            placeholder="Ej: TAG-100 o serie 88321"
            value={instrumentTagSerialFilter}
            onChange={(e) => setInstrumentTagSerialFilter(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
